var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNodataNoDataNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 101.89,
    y1: 203.73,
    x2: 94.81,
    y2: 196.65,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#6679b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bbccf8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 10.42,
    y1: 100.45,
    x2: 70.04,
    y2: 160.06,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c6caef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5f4f9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 32.95,
    y1: 172.89,
    x2: 32.95,
    y2: 53.38,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#87abd1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 40.65,
    y1: 246.58,
    x2: 40.65,
    y2: 114.38,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 20.54,
    y1: 114.95,
    x2: 83.52,
    y2: 159.44,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 29.06,
    y1: 112.16,
    x2: 56.15,
    y2: 151.67,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 81.79,
    y1: 173.05,
    x2: -7.95,
    y2: 83.32,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#343451"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a4b6e5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 23.8,
    y1: 108.16,
    x2: 62.05,
    y2: 107.69,
    gradientTransform: "translate(0 2)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#00b09b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#96c93d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 32.94,
    y1: 109.57,
    x2: 47.33,
    y2: 109.57,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 5.59,
    y1: 124.77,
    x2: 47.45,
    y2: 99.85,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 36.16,
    y1: 114.94,
    x2: 53.62,
    y2: 138.74,
    xlinkHref: "#linear-gradient-8"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 16.41,
    y1: 113.67,
    x2: 33.08,
    y2: 113.67,
    xlinkHref: "#linear-gradient-8"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M158.09,54.33h-60.82v85.38h60.82c3.01,0,5.45-2.44,5.45-5.45V59.77c0-3.01-2.44-5.45-5.45-5.45h0Z",
    style: {
      fill: "#ccd0d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.44,54.33c-3.01,0-5.45,2.44-5.45,5.45v74.48c0,3.01,2.44,5.45,5.45,5.45h60.82V54.33H36.44Z",
    style: {
      fill: "#a7b0c1"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 35.17,
    y: 58.51,
    width: 124.18,
    height: 62.09,
    rx: 1.27,
    ry: 1.27,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M90.7,139.7h-9.55v8.96h-10.75v4.18h26.87v-6.57c-3.63,0-6.57-2.94-6.57-6.57Z",
    style: {
      fill: "#ccd0d9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.54,148.66h-10.75v-8.96h-8.96c0,3.63-2.94,6.57-6.57,6.57v6.57h26.27v-4.18Z",
    style: {
      fill: "#a7b0c1"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M161.2,111.33v-.73c0-1.19-.97-2.17-2.17-2.17h-22.59c-1.19,0-2.17,.97-2.17,2.17v39.06h53.83v-36.15c0-1.19-.97-2.17-2.17-2.17h-24.74Z",
    style: {
      fill: "#ffdf4f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.67,
    y: 114.44,
    width: 49.55,
    height: 35.6,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.43,118.9l-.8,2.21h-23.18c-1.19,0-2.17,.97-2.17,2.17v27.58c0,1.19,.97,2.17,2.17,2.17h49.5c1.19,0,2.17-.97,2.17-2.17v-31.22c0-1.19-.97-2.17-2.17-2.17h-23.48c-.91,0-1.73,.57-2.04,1.43h0Z",
    style: {
      fill: "#ffcc01"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.11,150.86v-17.98c-14.95,14.54-40.88,18.44-53.23,19.48,.39,.41,.95,.67,1.56,.67h49.5c1.19,0,2.17-.97,2.17-2.17Z",
    style: {
      fill: "#fcbd11"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.14,122.85h-18.31c-.97,0-1.75,.78-1.75,1.75v3.87c3.08-2.11,10.02-4.76,20.05-5.62Z",
    style: {
      fill: "#ffd715"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "17.54 124.97 17.54 148.72 32.95 157.61 48.36 148.72 48.36 124.97 17.54 124.97",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "17.54 124.97 32.95 133.87 48.36 124.97 32.95 116.07 17.54 124.97",
    style: {
      fill: "url(#linear-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.27 124.97 32.95 118.22 44.63 124.97 32.95 131.72 21.27 124.97",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.95 133.87 32.95 157.61 48.36 148.72 48.36 124.97 32.95 133.87",
    style: {
      fill: "url(#linear-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.95 118.22 32.95 131.72 21.27 124.97 32.95 118.22",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "32.95 118.22 44.63 124.97 32.95 131.72 32.95 118.22",
    style: {
      fill: "url(#linear-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.42 126.22 32.95 120.72 42.48 126.22 32.95 131.72 23.42 126.22",
    style: {
      fill: "url(#linear-gradient-7)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.44,126.99c-1.16-1.57-1.07-3.72-.73-5.64,.35-1.92,.91-3.87,.54-5.79-.44-2.26-2.08-4.05-3.24-6.04-2.92-5.13-2.69-11.47,.59-16.38-.37,2.64,1.21,4.89,2.64,7.1s3.16,4.36,3.75,6.94c.76,3.39-.51,6.87-1.73,10.12s-2.75,6.35-1.81,9.7h-.01Z",
    style: {
      fill: "url(#linear-gradient-8)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.34,126.55c-.82-3.06-.36-6.33,1.29-9.04,1.18-1.91,2.9-3.47,3.79-5.52,1.09-2.51,.79-5.39,1.52-8.03,1.02-3.57,3.82-6.36,7.39-7.39-.99,.9-1.23,2.36-1.22,3.7,.07,1.34,.3,2.67,.66,3.96,.38,1.28,.49,2.63,.33,3.96-.44,1.84-1.48,3.49-2.96,4.67-1.41,1.24-3.03,2.22-4.46,3.43-3.22,2.59-5.46,6.21-6.34,10.25h0Z",
    style: {
      fill: "url(#linear-gradient-9)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.1,126.76c-2.64-1.15-4.07-4.06-4.57-6.89-.5-2.83-.29-5.74-.75-8.59-.69-4.1-2.75-7.84-5.83-10.62,3.84-.04,7.13,2.21,9.13,5.49s2.58,7.27,2.33,11.12c-.21,3.24-.85,6.27-.3,9.49h0Z",
    style: {
      fill: "url(#linear-gradient-10)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.34,119.03c1.4-.94,2.88-1.74,4.43-2.42,1.55-.68,2.88-1.78,3.84-3.18,1.01,3.3-.31,6.86-3.22,8.7-1.47,.88-3.19,1.22-4.8,1.83-.97,.33-1.86,.84-2.64,1.49-.51,.45-.82,1.32-1.36,1.65-.42-.83,.17-2.55,.43-3.39,.59-1.87,1.75-3.5,3.31-4.69h0Z",
    style: {
      fill: "url(#linear-gradient-11)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.08,126.01c-2.14-.74-3.76-2.56-4.82-4.56s-1.67-4.2-2.42-6.34-1.68-4.27-3.31-5.88-3.96-2.6-6.16-2.05c1.47-1.26,3.36-1.92,5.29-1.86,1.95,.11,3.79,.93,5.18,2.3,2.38,2.38,2.98,5.95,3.45,9.25s.45,6.7,2.78,9.13h0Z",
    style: {
      fill: "url(#linear-gradient-12)"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 33.38,
    cy: 63.88,
    r: 21.49,
    style: {
      fill: "#ec2027"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "45.32 55.77 41.49 51.94 33.38 60.05 25.27 51.94 21.44 55.77 29.55 63.88 21.44 71.99 25.27 75.82 33.38 67.71 41.49 75.82 45.32 71.99 37.22 63.88 45.32 55.77",
    style: {
      fill: "#fff"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodataNoDataNoData);
export default __webpack_public_path__ + "static/media/nodata_NoData_NoData.0426e3bf1d041e3b3505299db559fd52.svg";
export { ForwardRef as ReactComponent };